/**
 * Folder-tree runtime context: rename/creatable/sort mode handlers composed for tree nodes and toolbar.
 */ import { useRef } from "react";
import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FOLDER_TREE_RUNTIME_SYMBOL = Symbol();
const useFolderTreeRuntime = ()=>useImmutableContext(FOLDER_TREE_RUNTIME_SYMBOL);
function useFolderTreeRuntimeProvider(refActions) {
    const runtimeRef = useRef(refActions);
    runtimeRef.current = refActions;
    return useImmutableContextProvider(FOLDER_TREE_RUNTIME_SYMBOL, {}, {}, {
        inherit: [],
        refActions: {
            onRenameClose: (_ctx, save, input, props)=>runtimeRef.current.onRenameClose?.(save, input, props),
            onAddClose: (_ctx, save, input, props)=>runtimeRef.current.onAddClose?.(save, input, props),
            onNodePressF2: (_ctx, props)=>runtimeRef.current.onNodePressF2?.(props),
            handleCreatableHeaderClick: (_ctx, type, consumerOnClick)=>runtimeRef.current.handleCreatableHeaderClick?.(type, consumerOnClick),
            resolveBuiltInToolbarAction: (_ctx, action, buttonId)=>runtimeRef.current.resolveBuiltInToolbarAction?.(action, buttonId) ?? {}
        }
    });
}
export { useFolderTreeRuntime, useFolderTreeRuntimeProvider };
